import { render, staticRenderFns } from "./SerpTips.vue?vue&type=template&id=e684e60c&scoped=true&"
import script from "./SerpTips.vue?vue&type=script&lang=js&"
export * from "./SerpTips.vue?vue&type=script&lang=js&"
import style0 from "./SerpTips.vue?vue&type=style&index=0&id=e684e60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e684e60c",
  null
  
)

export default component.exports